var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgClients = function SvgClients(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    viewBox: "0 0 18 18",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.75v-1.5a3 3 0 0 0-3-3H3.75a3 3 0 0 0-3 3v1.5M6.375 8.25a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12.75 8.25l1.5 1.5 3-3"
  })));
};
export { SvgClients as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMiAxNS43NVYxNC4yNUMxMiAxMy40NTQ0IDExLjY4MzkgMTIuNjkxMyAxMS4xMjEzIDEyLjEyODdDMTAuNTU4NyAxMS41NjYxIDkuNzk1NjUgMTEuMjUgOSAxMS4yNUgzLjc1QzIuOTU0MzUgMTEuMjUgMi4xOTEyOSAxMS41NjYxIDEuNjI4NjggMTIuMTI4N0MxLjA2NjA3IDEyLjY5MTMgMC43NSAxMy40NTQ0IDAuNzUgMTQuMjVWMTUuNzUiIC8+CjxwYXRoIGQ9Ik02LjM3NSA4LjI1QzguMDMxODUgOC4yNSA5LjM3NSA2LjkwNjg1IDkuMzc1IDUuMjVDOS4zNzUgMy41OTMxNSA4LjAzMTg1IDIuMjUgNi4zNzUgMi4yNUM0LjcxODE1IDIuMjUgMy4zNzUgMy41OTMxNSAzLjM3NSA1LjI1QzMuMzc1IDYuOTA2ODUgNC43MTgxNSA4LjI1IDYuMzc1IDguMjVaIiAvPgo8cGF0aCBkPSJNMTIuNzUgOC4yNUwxNC4yNSA5Ljc1TDE3LjI1IDYuNzUiIC8+Cjwvc3ZnPgo=";